import { Injectable, NgModule } from '@angular/core';
import { WhenScrolledDirective } from './when-scrolled.directive';
import { WhenScrolledService } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.service';

@NgModule({
    declarations: [WhenScrolledDirective],
    exports: [WhenScrolledDirective],
    providers: [WhenScrolledService],
})
export class FiWhenScrolledModule {}
